import React from 'react';

export function VisitorManagementSchedulingTab(): React.ReactElement {
  return (
    <div>
      <div>Scheduling</div>
    </div>
  );
}
